import React, { useState, useContext } from "react";
import { Route } from "react-router-dom";
import { userContext } from "../../App";
import axios from "axios";
import { useHistory } from "react-router-dom";
import "./Fav.css";
import swal from "sweetalert";
const Favourite = ({ bookId }) => {
  const [favourite, setFavourite] = useState();
  const state = useContext(userContext);
  const token = state.token;
  const history = useHistory();
  const adding = () => {
    if (!token) {
      swal({
        title: "You have to login first so you can add Favourite",
        icon: "error",
        button: "OK",
      });
    }
    axios
      .post(
        "https://c3-bookshop.herokuapp.com/favorite",
        { bookId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        swal({
          title: "success added to Favourite ",
          icon: "success",
          button: "OK",
        });
        setFavourite("Done!🌟");
      })
      .catch((err) => {
       
      });
  };
  return (
    <div>
      <p className="btnfav" onClick={adding}>
        ⭐
      </p>
    </div>
  );
};
export default Favourite;
